import {PixiObject} from "../primitives/pixi-object";
import {ImageDrawable} from "./image.pixi";
import {BlueprintContext} from "../../../world/cyanprints/i-blueprint-context";
import {Graphics} from "pixi.js";
import {DRect} from "../../../primitives/drawable-rect";


export class ImageGallery extends PixiObject {
    private images: ImageDrawable[] = [];
    private blueprintContext: BlueprintContext;

    constructor(config?: {
        id?: string,
        blueprintContext: BlueprintContext
    }) {
        super(config);
        this.blueprintContext = config.blueprintContext;
        // this.addDebugRect(100, 100);
    }

    /**
     * Add an image to the gallery
     */
    public async addImage(
        imageData: {
            fileId?: string,
            url?: string;
            base64Source?;
            name: string
        }
    ) {
        const {cols, spacing, containerWidth, itemWidth, itemHeight} = this.calcLayout();
        const imageItem = new ImageDrawable({
            id: `img-${this.images.length}`,
            url: imageData.url,
            fileId: imageData.fileId,
            fitInSquareSize: itemWidth,
            blueprintContext: this.blueprintContext
        });
        await imageItem.createOrUpdate({})
        this.addChild(imageItem);
        this.images.push(imageItem);
        this.layout();
        return imageItem;
    }

    addDebugRect(width, height) {
        const graphics = new Graphics({});
        const rect = new DRect({
            left: 0,
            top: 0,
            right: width,
            bottom: height,
            roundness: 5,
            colour: "#ffffff",
        });
        rect.render(graphics);
        this.sprite.addChild(graphics);
    }


    /**
     * Layout images in a grid
     */
    private layout() {
        const {cols, spacing, containerWidth, itemWidth, itemHeight} = this.calcLayout();
        let height = 0
        this.images.forEach((image, index) => {
            const col = index % cols;
            const row = Math.floor(index / cols);

            image.sprite.x =  col * (itemWidth + spacing);
            image.sprite.y = row * (itemHeight + spacing);
            image.sprite.width = itemWidth;
            image.sprite.height = itemHeight;
            // if (this.images.length == 1) {
            //     if (image.imageSprite.width > image.imageSprite.height) {
            //         image.sprite.height = image.imageSprite.height;
            //         height = image.sprite.height;
            //     }
            // }
            // if (this.images.length > 1) {
            //     image.center()
            // }

            // Update touch bounds after positioning
            // image.updateTouchBounds();
        });
        this.updateTouchBounds()
    }

    private calcLayout() {
        const cols = this.calcColumns(this.images.length);
        const spacing = 10;
        let containerWidth = 600;
        let imageTotalWidth = containerWidth / cols;
        const itemWidth = imageTotalWidth - (spacing * (cols + 1));
        const itemHeight = itemWidth;
        return {
            cols, spacing, containerWidth, imageTotalWidth, itemWidth, itemHeight
        }
    }

    public calcColumns(imageCount: number) {
        const imagesToImagesPerRow = {
          0:1, 1: 1, 2: 2, 3: 2, 4: 3, 5: 5, 6: 3, 7: 5, 8: 4, 9: 3,
        };
        let imagesPerRow = imagesToImagesPerRow[imageCount] ?? 5;
        return imagesPerRow
    }

    override setupDefaultInteractions() {
        // Click on image to view full size
        this.touchPrimitive.onPressed( (pt) => {
            console.log('Gallery clicked:', this.id);
            this.sprite.alpha = 0.5;
            this.requestRender()
            return true; // Stop propagation
        });
        this.touchPrimitive.onReleased( (pt) => {
            this.sprite.alpha = 1;
            this.requestRender()
            return true; // Stop propagation
        });
    }

}